var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewOfferBg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 260,
  fill: "none",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#new-offer-bg_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m22.947 163.331 17.865 96.135 96.135-17.865-17.865-96.135z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#49B989",
  fillRule: "evenodd",
  d: "m60.253 364.078 2.95 15.88 176.37-256.884-15.88 2.951zm191.682-218.653-2.951-15.881L72.623 386.416l15.88-2.951zm2.951 15.878 2.95 15.878-137.577 200.382-15.877 2.951zm8.852 47.636-2.951-15.88-124.649 181.553 15.879-2.951zm2.951 15.878 2.951 15.88-85.865 125.063-15.879 2.951zm8.852 47.636-2.95-15.878-72.937 106.234 15.877-2.951zm2.951 15.879 2.951 15.88-34.153 49.744-15.88 2.951zm8.853 47.637-2.951-15.878-21.225 30.914 15.878-2.95zm-230.043 12.23-2.95-15.877 137.585-200.395 15.877-2.951zm-8.853-47.635 2.951 15.879 124.658-181.565-15.879 2.951zm-2.95-15.879-2.952-15.88L128.42 143.73l15.88-2.951zm-8.853-47.638 2.95 15.879 72.945-106.245-15.88 2.951zm-2.951-15.879-2.951-15.879 34.16-49.755 15.88-2.951zm-8.853-47.636 2.95 15.878 21.233-30.925-15.878 2.951z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#new-offer-bg_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m145.014 240.102 110.253-20.49-17.865-96.134-110.253 20.489z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#49B989",
  d: "M195.079 202.625c30.354-5.641 60.382 18.505 67.137 54.383l-110.253 20.489c-6.483-35.825 12.763-69.231 43.116-74.872M194.332 198.591c-30.438 5.657-60.656-19.509-67.478-56.215l110.254-20.489c6.821 36.706-12.338 71.048-42.776 76.704"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M62.343 86.434C55.657 55.65 69.23 27.586 92.962 23.72l24.284 111.818c-23.702 3.683-48.2-18.234-54.903-49.104M55.412 88.864c6.704 30.87-7.002 58.955-30.62 62.714L.508 39.76c23.618-3.758 48.2 18.234 54.904 49.104"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M235.281 112.03 125.11 132.504l-20.474-110.17L214.807 1.858zm-88.432-40.411c2.36 12.701 14.571 21.084 27.272 18.724 12.702-2.36 21.085-14.57 18.724-27.272-2.36-12.702-14.57-21.085-27.272-18.724-12.701 2.36-21.084 14.57-18.724 27.272",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#new-offer-bg_svg__c)",
  d: "M13 109.863h218.13v152H13z",
  transform: "rotate(-10.53 13 109.863)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "new-offer-bg_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "m22.947 163.331 17.865 96.135 96.135-17.865-17.865-96.135z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "new-offer-bg_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "transparent",
  d: "m145.014 240.102 110.253-20.49-17.865-96.134-110.253 20.489z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "new-offer-bg_svg__c",
  x1: 122.065,
  x2: 122.065,
  y1: 109.863,
  y2: 261.863,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#49B989",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#49B989"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewOfferBg);
export default ForwardRef;